<template>
  <div>
    <CrudKeyboardShortcutsDialog v-model="dialog" :shortcuts="shortcuts" />
    <CrudSearchFieldDialog
      v-model="searchDialog"
      :fields="searchFields"
      @select="selectSearchField"
    />
  </div>
</template>

<script>
import CrudKeyboardShortcutsDialog from "@/components/base/Crud/CrudKeyboardShortcutsDialog.vue";
import CrudSearchFieldDialog from "@/components/base/Crud/CrudSearchFieldDialog.vue";
import {
  STANDALONE_CRUD_SEARCH_EVENT,
  STANDALONE_CRUD_SHORTCUTS_EVENT,
} from "@/mixins/standaloneCrudKeyboardShortcuts";

export default {
  name: "StandaloneCrudKeyboardShortcutsHost",
  components: { CrudKeyboardShortcutsDialog, CrudSearchFieldDialog },
  data() {
    return {
      dialog: false,
      shortcuts: [],
      searchDialog: false,
      searchFields: [],
      searchSelectionHandler: null,
    };
  },
  watch: {
    searchDialog(open) {
      if (!open) this.searchSelectionHandler = null;
    },
  },
  mounted() {
    this.$root.$on(STANDALONE_CRUD_SHORTCUTS_EVENT, this.open);
    this.$root.$on(STANDALONE_CRUD_SEARCH_EVENT, this.openSearch);
  },
  beforeDestroy() {
    this.$root.$off(STANDALONE_CRUD_SHORTCUTS_EVENT, this.open);
    this.$root.$off(STANDALONE_CRUD_SEARCH_EVENT, this.openSearch);
  },
  methods: {
    open({ shortcuts = [] } = {}) {
      this.shortcuts = shortcuts;
      this.dialog = true;
    },
    openSearch({ fields = [], onSelect = null } = {}) {
      if (!fields.length || typeof onSelect !== "function") return;
      this.dialog = false;
      this.searchFields = fields;
      this.searchSelectionHandler = onSelect;
      this.searchDialog = true;
    },
    selectSearchField(fieldId) {
      const handler = this.searchSelectionHandler;
      this.searchDialog = false;
      handler?.(fieldId);
    },
  },
};
</script>
